const RING_DURATION = 8;
const BASE_SIZE = 60;

// Sampled directly from the brand: the same three stops as .gradient-text
// (the "Digital Growth." headline — brand cyan → #00AEEF → #007AFF), plus
// the logo's own navy core. No colors introduced outside these two places.
const HUES = [
  "rgba(0, 229, 255, 0.6)",
  "rgba(0, 174, 239, 0.55)",
  "rgba(0, 122, 255, 0.5)",
  "rgba(11, 31, 58, 0.55)",
];

/** One sonar pulse: a small ring anchored off-canvas (left or right) that
 * scales up while fading out, on an infinite CSS loop (see `.hero-ripple` /
 * `hero-ripple` keyframes in index.css). `delay` staggers each instance so
 * several rings are always mid-flight, producing a continuous ripple train. */
const Ring = ({ side, hue, delay }) => (
  <div
    className="absolute pointer-events-none"
    style={{ [side]: -BASE_SIZE / 2, top: "42%", width: BASE_SIZE, height: BASE_SIZE, transform: "translateY(-50%)" }}
  >
    <div
      className="hero-ripple w-full h-full rounded-full"
      style={{
        border: `1px solid ${hue}`,
        boxShadow: `0 0 12px 1px ${hue}`,
        animation: `hero-ripple ${RING_DURATION}s ${delay}s ease-out infinite`,
      }}
    />
  </div>
);

/** Full-bleed hero background: two mirrored sonar-pulse trains emanating
 * from the left/right edges, plus film grain — no WebGL, no particle
 * system, no grid (the reference hero has none). Pure CSS animation so it
 * can't silently freeze the way the earlier Framer Motion version did;
 * reduced-motion users get a static faint ring via the global CSS rule. */
// Feathers the ring layer's own alpha toward the bottom edge so the glow
// dissolves into the shared global background instead of being clipped by
// `overflow-hidden` — no opaque overlay is ever painted, so the site-wide
// grid/aurora underneath stays visible and continuous the whole way down.
const FADE_MASK = "linear-gradient(to bottom, black 75%, transparent 100%)";

export const HeroWebGL = () => {
  const step = RING_DURATION / HUES.length;

  return (
    <div
      className="absolute inset-0 -z-10 overflow-hidden pointer-events-none"
      style={{ maskImage: FADE_MASK, WebkitMaskImage: FADE_MASK }}
      aria-hidden="true"
    >
      {HUES.map((hue, i) => (
        <Ring key={`l-${i}`} side="left" hue={hue} delay={i * step} />
      ))}
      {HUES.map((hue, i) => (
        <Ring key={`r-${i}`} side="right" hue={hue} delay={i * step + step / 2} />
      ))}
      <div
        className="absolute inset-0 opacity-[0.03] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
    </div>
  );
};

export default HeroWebGL;
